import { render, staticRenderFns } from "./CarAwsDocuments.vue?vue&type=template&id=39ca3baf&scoped=true"
import script from "./CarAwsDocuments.vue?vue&type=script&lang=ts"
export * from "./CarAwsDocuments.vue?vue&type=script&lang=ts"
import style0 from "./CarAwsDocuments.vue?vue&type=style&index=0&id=39ca3baf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ca3baf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39ca3baf')) {
      api.createRecord('39ca3baf', component.options)
    } else {
      api.reload('39ca3baf', component.options)
    }
    module.hot.accept("./CarAwsDocuments.vue?vue&type=template&id=39ca3baf&scoped=true", function () {
      api.rerender('39ca3baf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cars/CarAwsDocuments.vue"
export default component.exports